var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.66668C13.4267 8.66668 11.3333 10.76 11.3333 13.3333C11.3333 15.9067 13.4267 18 16 18C18.5733 18 20.6667 15.9067 20.6667 13.3333C20.6667 10.76 18.572 8.66668 16 8.66668ZM16 16.6667C14.1627 16.6667 12.6667 15.1707 12.6667 13.3333C12.6667 11.496 14.1627 10 16 10C17.8373 10 19.3333 11.496 19.3333 13.3333C19.3333 15.1707 17.8373 16.6667 16 16.6667ZM15.9947 3.33334C10.2973 3.33334 6 7.63201 6 13.3333C6 21.4507 12.212 26.5213 14.8813 28.324C15.2187 28.552 15.6067 28.6667 15.9947 28.6667C16.3813 28.6667 16.768 28.5534 17.1053 28.3254C19.78 26.5187 26 21.4414 26 13.332C26 7.63204 21.6973 3.33334 15.9947 3.33334ZM16.36 27.22C16.1373 27.3693 15.8507 27.3693 15.628 27.2187C13.6827 25.9053 7.33333 21.0214 7.33333 13.332C7.33333 8.39071 11.056 4.66537 15.9947 4.66537C20.9387 4.66537 24.6667 8.39071 24.6667 13.332C24.6667 20.8027 18.856 25.5333 16.36 27.22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.1a377e1733113347451e9cd64de318af.svg";
export { ForwardRef as ReactComponent };